// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner--spinner--OPlEZ","graphic":"Spinner--graphic--FY9vz","spin":"Spinner--spin--AJhwi"};